import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ProjectDto, UserRoleDto} from "../../data/CommandServiceDtos.generated";
import { ProjectCardMetricsDto } from '../project-thumbnail/project-card-metrics.model';


@Component({
  standalone: false,
  selector: 'project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit {
 
  @Input() projects: ProjectDto[];
  @Input() clientCount: number;
  @Input() userRoles: UserRoleDto[];
  @Input() cardMetricsById: { [projectId: number]: ProjectCardMetricsDto } = {};
  @Input() metricsPendingById: { [projectId: number]: boolean } = {};
  @Input() metricsLoading = false;
  @Output() favoriteToggled = new EventEmitter<ProjectDto>();

  constructor() { }

  ngOnInit() {
  }

  onlyTwoItems() {
    if (this.projects.length === 2) 
      return true;

    return false;

  }

  trackByProjectId(_index: number, project: ProjectDto) {
    return project && project.ProjectId;
  }

  isMetricsPlaceholder(projectId: number): boolean {
    return !!(this.metricsPendingById && this.metricsPendingById[projectId])
      && !(this.cardMetricsById && this.cardMetricsById[projectId]);
  }
}
